import Swal from "sweetalert2";
import { Injectable, WritableSignal, inject, signal } from "@angular/core";
import { BeforeUnloadService } from "src/app/services/before-unload.service";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { sntTranslate } from "src/app/support/translate";

type ConfirmResult = {
  confirmed: boolean;
  denied?: boolean;
  value: string;
};

@Injectable()
export class ConfirmService {
  withText(
    title: string,
    description: string,
    text: string,
    options?: {
      confirmText?: string;
      cancelText?: string;
      width?: number;
      customClass?: Record<string, string>;
    }
  ): Promise<boolean | ConfirmResult> {
    return new Promise((res) => {
      Swal.fire({
        title: title,
        html: `
      <div class="flex flex-col items-start gap-6 pl-2">
        <div>
          ${description}
        </div>

        <div>
          ${sntTranslate(marker("Per confermare l'azione, scrivi"))} <i>${text}</i>.
        </div>
      </div>`,
        icon: "warning",
        showCancelButton: true,
        showConfirmButton: true,
        allowOutsideClick: false,
        input: "text",
        inputPlaceholder: text,
        //inputLabel:
        //,
        confirmButtonText: options?.confirmText
          ? options.confirmText
          : sntTranslate(marker("Si")),
        cancelButtonText: options?.cancelText
          ? options.cancelText
          : sntTranslate(marker("No")),
        reverseButtons: true,
        focusCancel: false,
        focusConfirm: false,
        focusDeny: false,
        showClass: {
          backdrop: "swal2-noanimation",
          popup: "",
          icon: ""
        },
        hideClass: {
          popup: "" // disable popup fade-out animation
        },
        customClass: options?.customClass,
        toast: false,
        width: options?.width,
        inputValidator: (value: string) => {
          if (!value) {
            return sntTranslate(marker("Valore richiesto"));
          }

          if (value !== text) {
            return sntTranslate(marker("Il valore inserito non corrisponde"));
          }

          return null;
        }
      }).then((result) => {
        res(result.isConfirmed);
      });
    });
  }
}
